<template>
  <div class="satisfaction">
    <div class="add">
      <el-button type="primary" plain @click="handleAdd()">
        新增满意度评价
      </el-button>
    </div>
    <div class="item" v-for="(item, index) in data" :key="index">
      <template v-for="(field, idx) in field_list_view">
        <div :key="idx" v-if="idx < 3">
          <span>{{ field.field_txt }}：</span
          >{{ item[field.field_name] || '- -' }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { structure, online } from '@/api/platform'
export default {
  data () {
    return {
      data: [],
      field_list_view: []
    }
  },
  components: {},
  created () { },
  computed: {
    user () {
      return localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {}
    }
  },
  mounted () {
    this.online()
    this.structure()
  },
  methods: {
    async online () {
      const { result } = await online({
        form_head_uuid: '6cc861f99a644963a1fb694b63be2c14',
        needpage: false,
        page: 1,
        limit: 1000,
        eg9dwtvttwtizeoe:this.user.id + ''
        // filters: [
        //   {
        //     key: 'eg9dwtvttwtizeoe',
        //     value: this.user.id + ''
        //   }
        //   //   eg9dwtvttwtizeoe: this.member.id + ''
        // ]
      })
      //   console.log(result);
      this.data = result
    },
    async structure () {
      const { result } = await structure('6cc861f99a644963a1fb694b63be2c14')
      this.field_list_view = result.field_list_view.filter(
        (item) => item.field_type !== 'remark' && !item.field_extend_json.hidden
      )
    },
    handleAdd () {
      window.open(`https://paas.ontuotu.com/#/270ab0c29e5411ee9b8b0242321230b4/preview/6cc861f99a644963a1fb694b63be2c14?eg9dwtvttwtizeoe=${this.user.id}`, '_blank')
    }
  },
}
</script>
<style lang="less"  scoped>
.add {
  margin-bottom: 20px;
}
.item {
  padding: 20px;
  border: 1px solid #dbdbdb;
  margin-bottom: 20px;
  font-size: 12px;
  color: #666;
  position: relative;
  div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 28px;
    span {
      color: #999;
      //   width: 60px;
      text-align: right;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/client/Satisfaction.vue